import React from "react";
import { useParams } from "react-router";

import { usePosition } from "use-position";

import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

import { StateContext } from "../../contexts/Context";

export const Driver = () => {
  const [successMsg, setSuccessMsg] = React.useState("");
  const [failureMsg, setFailureMsg] = React.useState("");
  const [isOpenSuccessAlert, setIsOpenSuccessAlert] = React.useState(false);
  const [isOpenFailureAlert, setIsOpenFailureAlert] = React.useState(false);

  const { isWsConnected, websocket } = React.useContext(StateContext);

  const params = useParams();
  const { latitude, longitude, accuracy, error: positionError } = usePosition();

  const onCloseSuccessAlert = React.useCallback(() => {
    setIsOpenSuccessAlert(false);
  }, []);

  const onCloseFailureAlert = React.useCallback(() => {
    setIsOpenFailureAlert(false);
  }, []);

  React.useEffect(() => {
    if (latitude && longitude && isWsConnected && params.code) {
      const body = JSON.stringify({
        data: {
          type: "driver",
          phone: params.code,
          position: { latitude, longitude, accuracy },
        },
        action: "message",
      });
      websocket.send(body);

      setSuccessMsg("Your location successfully submitted.");
      setIsOpenSuccessAlert(true);
    }
  }, [accuracy, isWsConnected, latitude, longitude, params.code, websocket]);

  React.useEffect(() => {
    if (positionError) {
      setFailureMsg(positionError);
      setIsOpenFailureAlert(true);
    }
  }, [positionError]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isOpenFailureAlert}
        onClose={onCloseFailureAlert}
        key="top-right-error"
      >
        <Alert onClose={onCloseFailureAlert} severity="error">
          {failureMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isOpenSuccessAlert}
        onClose={onCloseSuccessAlert}
        key="top-right-success"
      >
        <Alert onClose={onCloseSuccessAlert} severity="success">
          {successMsg}
        </Alert>
      </Snackbar>
    </>
  );
};
